import * as React from 'react'

export type SelectionChipProps = {
  selected: boolean
  onClick: () => void
  children: React.ReactNode
  /** Optional trailing note, e.g. a price delta (`+$1,900`). Rendered muted. */
  trailing?: React.ReactNode
  disabled?: boolean
}

/**
 * One option in a single-select group (PDP variant selectors, bundle slots).
 * Selected = primary-color tint + border + text; unselected = neutral border +
 * body text. Token-aligned with the button system (same brand vars) but
 * deliberately independent of the per-tier Filled/Outline button toggle — a
 * dealer choosing "tertiary = filled" must never make an unselected chip look
 * selected.
 */
export function SelectionChip({ selected, onClick, children, trailing, disabled }: SelectionChipProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      className={`px-4 py-2 rounded-[var(--layout-card-radius,var(--brand-radius,0.5rem))] border text-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
        selected
          ? 'border-[var(--color-primary)] bg-[color-mix(in_srgb,var(--color-primary)_8%,transparent)] text-[var(--color-primary)] font-medium'
          : 'border-[var(--color-border)] text-[var(--color-text)] hover:border-[var(--color-text-muted)]'
      }`}
    >
      {children}
      {trailing != null && <span className="ml-1 text-xs text-[var(--color-text-muted)]">{trailing}</span>}
    </button>
  )
}
